import { http, prepareHttpQuery } from 'http';

export default {
  getMasterData: () => http.get('/flex/transport/masterdata'),

  getTransportationList: filterData => {
    const baseUrl = `/flex/transport/list`;
    const queries = prepareHttpQuery(filterData);
    return http.get(`${baseUrl}${queries}`);
  },

  getTransportDrivers: idTransport => http.get(`/flex/transport/drivers/${idTransport}`),
  getOfflinePrint: () => http.get(`/flex/checkinoutOffline/print/`)
};
